/*
 * Babblee · quick add from a product card
 *
 * The plus turns into a tick — but only once Shopify has confirmed the line is
 * in the cart. Animating on click would be a lie the moment a request fails,
 * and a shopper who sees a tick and no item trusts nothing else on the page.
 *
 * If fetch is unavailable or the request fails, the real form posts, which is
 * the behaviour the button would have had anyway.
 */
(function () {
  var RESET_MS = 1800;

  function badge(count) {
    document.querySelectorAll('.bb-head__cart .bb-head__badge').forEach(function (el) {
      el.textContent = String(count);
      el.hidden = count === 0;
    });
    // The cart icon has no badge element until there is something in the cart.
    if (count > 0 && !document.querySelector('.bb-head__cart .bb-head__badge')) {
      var cart = document.querySelector('.bb-head__cart');
      if (cart) {
        var span = document.createElement('span');
        span.className = 'bb-head__badge';
        span.textContent = String(count);
        cart.appendChild(span);
      }
    }
  }

  function refreshCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) badge(cart.item_count); })
      .catch(function () { /* the count is cosmetic; never block on it */ });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var button = form.querySelector('[data-bb-add]');
    if (!button || !form.classList.contains('bb-pc__addform')) return;
    if (!window.fetch) return;

    event.preventDefault();
    if (button.classList.contains('is-busy')) return;
    button.classList.add('is-busy');

    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (response) {
        if (!response.ok) throw new Error('add');
        return response.json();
      })
      .then(function () {
        button.classList.remove('is-busy');
        button.classList.add('is-added');
        button.setAttribute('aria-label', 'Added to cart');
        return refreshCount();
      })
      .then(function () {
        window.setTimeout(function () {
          button.classList.remove('is-added');
          button.setAttribute('aria-label', button.getAttribute('data-label') || 'Add to cart');
        }, RESET_MS);
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () {
        // Never leave a tick on a failed add: hand back to the real form post.
        button.classList.remove('is-busy', 'is-added');
        form.submit();
      });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshCount);
  } else {
    refreshCount();
  }
})();
